module.exports = "\n<mp-app [app]=\"appInfo\"></mp-app>\n"